import { EventEmitter } from '@angular/core';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { Report } from '../../../../models/measure/report';
import { UserService } from '../../../services/user.service';
import { DatePipe } from '@angular/common';
import { DateRange } from '../../../../models/date-range';
import { DateUtils } from '../../../utils/date.utils';
import { UserActionType } from '../../../services/event-tracker/event-tracker.service';
export var MeasureReportTimeline;
(function (MeasureReportTimeline) {
    MeasureReportTimeline[MeasureReportTimeline["A_WEEK"] = 7] = "A_WEEK";
    MeasureReportTimeline[MeasureReportTimeline["A_HALF_MONTH"] = 15] = "A_HALF_MONTH";
    MeasureReportTimeline[MeasureReportTimeline["A_MONTH"] = 30] = "A_MONTH";
    MeasureReportTimeline[MeasureReportTimeline["TWO_MONTH"] = 60] = "TWO_MONTH";
})(MeasureReportTimeline || (MeasureReportTimeline = {}));
var MeasureSettingComponent = /** @class */ (function () {
    function MeasureSettingComponent(datePipe, modalService, userService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.userService = userService;
        this.selectPeriodEvent = new EventEmitter();
        this.deleteReportEvent = new EventEmitter();
        this.allowToEditReportEvent = new EventEmitter();
        this.selectedReport = new Report();
        this.periodChange = new EventEmitter();
        this.showDateRangePopup = false;
    }
    MeasureSettingComponent.prototype.onShowDeleteWarningPopup = function (e) {
        this.modalService.openInCenter(this.deleteReportWarning);
    };
    MeasureSettingComponent.prototype.onAllowToEditReport = function (e) {
        this.allowToEditReportEvent.emit(e);
    };
    MeasureSettingComponent.prototype.hideDeleteWarningPopup = function () {
        this.modalService.close();
    };
    MeasureSettingComponent.prototype.onChangePeriod = function (selectedPeriod) {
        this.selectPeriodEvent.emit(selectedPeriod);
        this.showDateRangePopup = false;
    };
    MeasureSettingComponent.prototype.deleteReport = function () {
        this.deleteReportEvent.emit(this.selectedReport);
        this.modalService.close();
    };
    MeasureSettingComponent.prototype.getReportName = function (selectedReport) {
        return selectedReport ? selectedReport.name : '';
    };
    MeasureSettingComponent.prototype.isPersistedReport = function () {
        return this.selectedReport && this.selectedReport.id > 0 && !this.selectedReport.is_default_report;
    };
    Object.defineProperty(MeasureSettingComponent.prototype, "isFreeUser", {
        get: function () {
            return this.userService.isFreeUser();
        },
        enumerable: true,
        configurable: true
    });
    MeasureSettingComponent.prototype.getMeasureContextByAction = function (actionType) {
        if (actionType === 'delete') {
            var params = this.measureActionContext.params;
            var modifiedParams = Object.assign({}, params, {
                action: UserActionType.DELETE
            });
            return Object.assign({}, this.measureActionContext, {
                params: modifiedParams
            });
        }
        return this.measureActionContext;
    };
    MeasureSettingComponent.prototype.hideDateRangePopup = function (evt) {
        if (this.showDateRangePopup) {
            this.showDateRangePopup = false;
        }
    };
    MeasureSettingComponent.prototype.onClickDateRangePopup = function (evt) {
        if (this.showDateRangePopup) {
            this.showDateRangePopup = false;
        }
        else {
            this.showDateRangePopup = true;
        }
    };
    Object.defineProperty(MeasureSettingComponent.prototype, "formatReportDateRange", {
        get: function () {
            if (!this.selectedPeriod) {
                return '';
            }
            var fromDate = this.datePipe.transform(this.selectedPeriod.startDate, 'MMM d');
            var fromDateSuffix = DateUtils.getDateSuffix(this.selectedPeriod.formattedStartDate);
            var endDate = this.selectedPeriod.formattedEndDate;
            var toDate = this.datePipe.transform(this.selectedPeriod.endDate, 'MMM d');
            var toDateSuffix = DateUtils.getDateSuffix(endDate);
            if (this.selectedPeriod.startDate === this.selectedPeriod.endDate) {
                return "" + toDate + toDateSuffix + ", " + endDate.getFullYear();
            }
            else {
                return "" + fromDate + fromDateSuffix + " - " + toDate + toDateSuffix + ", " + endDate.getFullYear();
            }
        },
        enumerable: true,
        configurable: true
    });
    return MeasureSettingComponent;
}());
export { MeasureSettingComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-setting/measure-setting.component.ts.pre-build-optimizer.js